import module from 'fan/proyecto/module.js'
import template from './template.html'

const TIPO_COMISION_EMPRESA = 1
const TIPO_COMISION_EMPLEADO = 2

const metodoCalculoComisionPredeterminada = (idTipoComision) => {
  switch (idTipoComision) {
    case TIPO_COMISION_EMPRESA:
      return 1

    case TIPO_COMISION_EMPLEADO:
      return 3

    default:
      return null
  }
}

export class FanProyectoEsquemasEsquemaComisionComponent {
  data
  metodosCalculoComision
  tiposComision
  onChange
  catalogos = {
    metodosCalculoComision: [],
    tiposComision: [],
  }

  $onChanges (changes) {
    if (changes.tiposComision) {
      this.catalogos.tiposComision = this.tiposComision
    }

    if (changes.data || changes.metodosCalculoComision) {
      this.filtrarMetodosCalculoComision()
    }
  }

  filtrarMetodosCalculoComision () {
    this.catalogos.metodosCalculoComision = this.metodosCalculoComision.filter((item) => item.id_tipo_comision === this.data.id_tipo_comision)
    console.log('this.data.id_tipo_comision', this.data.id_tipo_comision)
    console.log(this.metodosCalculoComision)
    console.log(this.catalogos.metodosCalculoComision)
  }

  notificar () {
    this.onChange({$event: {detail: this.data}})
  }

  validar () {
    this.data.id_metodo_calculo_comision = metodoCalculoComisionPredeterminada(this.data.id_tipo_comision)
    this.data.comision_porcentaje = (this.data.id_tipo_comision === 1 && this.data.comision_porcentaje) || null

    this.filtrarMetodosCalculoComision()
    this.notificar()
  }
}

module.component('fanProyectoEsquemasEsquemaComision', {
  controller: FanProyectoEsquemasEsquemaComisionComponent,
  template,
  bindings: {
    data: '<',
    metodosCalculoComision: '<',
    tiposComision: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/comision/component.js